
export type TweetFeedResponseTweetsItemTags = {
  hashtagIds?: string[];
};
